<template>
  <div :class="['mobile-content-box', colorStyle]"  @click="onClicked">
    <div class="mobile-content-box-title">
      <i v-if="showNextIcon" class="float-right far fa-chevron-right mobile-content-box-next-icon"></i>
      <i :class="[iconStyle, 'mx-1', icon, iconClass]"></i> <span class="ml-1">{{title}}</span>
      <slot name="title" />
    </div>
    <div class="mobile-content-box-content">
      <slot />
    </div>
  </div>
</template>


<script>
export default {
  name: 'MobileContentBox',
  props: {
    title: String,
    colorStyle: {
      type: String,
      default: 'primary'
    },
    icon: String,
    iconStyle: {
      type: String,
      default: 'far'
    },
    iconClass: String,
    showNextIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClicked(evt) {
      this.$emit('click', evt)
    }
  }
}
</script>